import { FetchError } from '@/lib/swr/fetcher'

let isSessionRedirectInProgress = false

export const redirectToLoginOnSessionExpired = () => {
  if (typeof window === 'undefined' || isSessionRedirectInProgress) {
    return
  }

  if (!window.location.pathname.startsWith('/auth')) {
    return
  }

  isSessionRedirectInProgress = true
  window.location.replace('/login?reason=session-expired')
}

export const getErrorStatus = (error: unknown): number | null => {
  if (error instanceof FetchError) {
    return error.status
  }

  if (typeof error === 'object' && error !== null && 'status' in error) {
    const status = (error as { status?: unknown }).status
    return typeof status === 'number' ? status : null
  }

  return null
}

export const isUnauthorizedError = (error: unknown) => {
  const status = getErrorStatus(error)
  return status === 401 || status === 419
}
